module.exports = __webpack_public_path__ + "static/img/13.8ede5da.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/2/eng/13.png
// module id = YVa3
// module chunks = 0